export type WorkspaceAgentSkillsFeatureFlags = {
  enableSkillsUi: boolean;
  workspaceAgentSkillsEnabled: boolean;
};

export const isWorkspaceAgentSkillsFullPageUiEnabled = ({
  enableSkillsUi,
  workspaceAgentSkillsEnabled,
}: WorkspaceAgentSkillsFeatureFlags): boolean => enableSkillsUi && workspaceAgentSkillsEnabled;
